import {
  ButtonGroup,
  closeCurrentDialog,
  FormButton,
  FormControl,
  Infobox,
} from 'platform/components';

import {FieldValues} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface RemapFormFooterProps<TFieldValues extends FieldValues> extends RequiredTestIdProps {
  control: FormControl<TFieldValues>;
  isSubmitDisabled: boolean;
}

/** The warning and the buttons are the same for both remap dialogs; only the submit rule differs. */
export function RemapFormFooter<TFieldValues extends FieldValues>(
  props: RemapFormFooterProps<TFieldValues>
) {
  return (
    <>
      <Infobox
        variant="warning"
        data={[
          {value: i18n.t('entity.customCatalogue.hints.replaceWarning')},
          {value: i18n.t('entity.customCatalogue.hints.makeNotFound')},
        ]}
      />

      <ButtonGroup align="right">
        <FormButton
          control={props.control}
          variant="secondary"
          title={i18n.t('general.actions.cancel')}
          onClick={closeCurrentDialog}
          data-testid={suffixTestId('cancel', props)}
        />
        <FormButton
          control={props.control}
          type="submit"
          variant="primary"
          title={i18n.t('general.actions.replace')}
          isDisabled={props.isSubmitDisabled}
          data-testid={suffixTestId('submit', props)}
        />
      </ButtonGroup>
    </>
  );
}
